import { render, staticRenderFns } from "./widgets.page.vue?vue&type=template&id=d2860188&scoped=true&"
import script from "./widgets.page.vue?vue&type=script&lang=js&"
export * from "./widgets.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2860188",
  null
  
)

export default component.exports